import { partial } from 'lodash-es'
import { put, call, takeEvery, select } from 'redux-saga/effects'

import {
  followPerson as followPersonApi,
  unfollowPerson as unfollowPersonApi,
  fetchSubscribers as fetchSubscribersApi,
} from '../api'
import { showNotice } from '../../Layout/Notices/Notices'

import createNamedActions from './actions.subscriptions'

const checkSubscribed = (state, identifier, namespace) => {
  return (
    state[namespace].subscriptionStates.get(identifier, {}).status ===
    'following'
  )
}
const getSubscriptionState = (state, namespace) =>
  state[namespace].subscriptionStates

function* onFollowPerson(actionNames, namespace, action) {
  const { identifier } = action
  const { identifierType } = action
  const isSubscribed = yield select(checkSubscribed, identifier, namespace)
  let apiMethod
  let successAction
  let errorAction

  yield put({
    type: actionNames.TOGGLE_FOLLOW_ENTITY_PROGRESS,
    identifier,
    identifierType,
  })

  if (isSubscribed) {
    apiMethod = unfollowPersonApi
    successAction = actionNames.UNFOLLOW_ENTITY_SUCCESS
    errorAction = actionNames.UNFOLLOW_ENTITY_FAILURE
  } else {
    apiMethod = followPersonApi
    successAction = actionNames.FOLLOW_ENTITY_SUCCESS
    errorAction = actionNames.FOLLOW_ENTITY_FAILURE
  }

  try {
    yield call(apiMethod, identifier)
    yield put({ type: successAction, identifier, identifierType })
  } catch (err) {
    yield put({ type: errorAction, identifier, identifierType })

    showNotice({
      message: 'Following status could not be updated.',
      expirationMillis: 5000,
      isClosable: true,
    })
  }
}

function* fetchSubscribers(actionNames) {
  try {
    const data = yield call(fetchSubscribersApi)
    yield put({ type: actionNames.FETCH_SUBSCRIBERS_SUCCESS, data })
  } catch (err) {
    showNotice({
      message: 'List of followers could not be loaded.',
      expirationMillis: 5000,
      isClosable: true,
    })
  }
}

function* fetchFollowingWorker(actionNames, namespace) {
  const subscriptionState = yield select(getSubscriptionState, namespace)

  if (subscriptionState.size === 0) {
    yield call(fetchSubscribers, actionNames)
  }
}

function* watchFollowing(actionNames, namespace) {
  yield call(fetchFollowingWorker, actionNames, namespace)
  yield takeEvery(
    actionNames.TOGGLE_FOLLOW_ENTITY,
    onFollowPerson,
    actionNames,
    namespace
  )
}

const createNamedSagas = (namespace) => {
  const { actionNames } = createNamedActions(namespace)

  return {
    watchFollowing: partial(watchFollowing, actionNames, namespace),
  }
}

export default createNamedSagas
